module.exports = __webpack_public_path__ + "media/images/landing/second/photo5-6f24c59c252326a38ee97aa702f8b871.jpg";